const API = {
  getDataList: '/h5AppApi/getDataList/', // 基础信息
  getEncodeInfo: '/h5AppApi/getEncodeInfo', // 查询二维码信息
  activation: '/h5AppApi/activation', // 激活
  check: '/h5AppApi/check' // 防伪查询
}

export default API
